import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { useCallback, useState } from 'react';
import { useAuthCore } from '../../core/modules/auth';
import { useMeCore } from '../../core/modules/me';
import { useGlobalCore } from '../../core/modules/global';
import { ME_USER_DIALOG } from '../../core/constants/dialog';

const UserMenu = () => {
  const { logout } = useAuthCore();
  const { user, getMeUser } = useMeCore();
  const { openDialog } = useGlobalCore();

  const [userMenu, setUserMenu] = useState(null);

  const userMenuClick = (e: any) => {
    setUserMenu(e.currentTarget);
  };

  const userMenuClose = () => {
    setUserMenu(null);
  };

  const onEditMe = useCallback(() => {
    userMenuClose();
    getMeUser();
    openDialog(ME_USER_DIALOG);
  }, [getMeUser, openDialog]);

  const onLogout = useCallback(() => {
    userMenuClose();
    logout();
  }, [logout]);

  return (
    <>
      <Button
        className="min-h-40 min-w-40 px-0 md:px-16 py-0 md:py-6"
        onClick={userMenuClick}
        color="inherit"
      >
        <div className="hidden md:flex flex-col mx-4 items-end">
          <Typography component="span" className="font-semibold flex">
            {user?.name}
          </Typography>
          {user?.privileges.superAdmin && (
            <Typography
              className="text-11 font-medium capitalize"
              color="text.secondary"
            >
              Super Admin
            </Typography>
          )}
        </div>

        <Avatar className="md:mx-4" alt="user avatar" />
      </Button>

      <Popover
        open={Boolean(userMenu)}
        anchorEl={userMenu}
        onClose={userMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        classes={{
          paper: 'py-8',
        }}
      >
        <MenuItem onClick={onEditMe}>
          <ListItemIcon className="min-w-40">
            <Person2OutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Perfil" />
        </MenuItem>
        <MenuItem onClick={onLogout}>
          <ListItemIcon className="min-w-40">
            <LogoutOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Cerrar Sesión" />
        </MenuItem>
      </Popover>
    </>
  );
};

export default UserMenu;
